type EvalType = 'self' | 'peer';
type PeerQuestionType = 'q1' | 'q2' | 'q3' | 'q4';
type SelfQuestionType = 'q1' | 'q2' | 'q3' | 'q4' | 'q5' | 'q6' | 'q7' | 'q8';
type QuestionType = PeerQuestionType | SelfQuestionType;

const SELF_EVAL_MAP: Record<number, number> = {
  5: 4,
  4: 3,
  3: 2,
  2: 1,
  1: 0,
};

const PEER_EVAL_MAP: Record<number, number> = {
  5: 3,
  4: 2,
  3: 1,
  2: 0,
  1: 0,
};

const PEER_Q3_REVERSE = true;

export function convertPolarity(
  evalType: EvalType,
  question: QuestionType,
  value: number
): number {
  if (evalType === 'self') {
    return SELF_EVAL_MAP[value] ?? 0;
  }

  if (evalType === 'peer') {
    if (question === 'q3' && PEER_Q3_REVERSE) {
      if (value === 3) return 1;
      if (value === 2) return 2;
      if (value === 1) return 3;
      return 0;
    }
    return PEER_EVAL_MAP[value] ?? 0;
  }

  return value;
}

export function normalizeChineseText(text: string): number {
  const normalized = text.trim();
  if (normalized === '全面达成' || normalized === '能' || normalized === '满意') return 4;
  if (normalized === '基本落实' || normalized === '偶尔能' || normalized === '基本满意') return 3;
  if (normalized === '局部尝试' || normalized === '不能' || normalized === '偶尔会' || normalized === '略有不满') return 2;
  if (normalized === '未能触达' || normalized === '不会' || normalized === '不满意') return 1;
  return 0;
}